export default "__VITE_ASSET__CbyZ557g__"